import { ErrorMessage } from "src/model/error-message";

export interface UserProfile {
    firstName: string,
    lastName: string,
    logonId: string,
    email: string,
    verificationData: {
        verified: boolean,
        hasToBeVerified: string,
        verificationDetails: {
            verifiedPhone: {
                verified: boolean
            },
            verifiedEmail: {
                verified: boolean;
            }
        }
    }
};

export interface UserCookies {
    user_type: string;
    user_id: string;
}

export interface UserDataProfile {
  user: UserProfile;
  userFromCookies: UserCookies;
}

export interface ProfileState {
    loading: boolean;
    loaded: boolean;
    user: UserProfile | null;
    needsToLogin: boolean;
    sessionExpired: boolean;
    lastLoad: number;
    error: ErrorMessage | null;
    userFromCookies: UserCookies | null;
}

export const profileInitialState: ProfileState = {
    loading: false,
    loaded: false,
    user: null,
    needsToLogin: false,
    sessionExpired: false,
    lastLoad: 0,
    error: null,
    userFromCookies: null
}